"use strict";
function _async_generator(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) {
                back = back.next = request;
            } else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof _await_value;
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) {
            resume(front.key, front.arg);
        } else {
            back = null;
        }
    }
    this._invoke = send;
    if (typeof gen.return !== "function") {
        this.return = undefined;
    }
}
if (typeof Symbol === "function" && Symbol.asyncIterator) {
    _async_generator.prototype[Symbol.asyncIterator] = function() {
        return this;
    };
}
_async_generator.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
_async_generator.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
_async_generator.prototype.return = function(arg) {
    return this._invoke("return", arg);
};
function _async_generator_delegate(inner, awaitWrap) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: awaitWrap(value)
        };
    }
    if (typeof Symbol === "function" && Symbol.iterator) {
        iter[Symbol.iterator] = function() {
            return this;
        };
    }
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") {
        iter.throw = function(value) {
            if (waiting) {
                waiting = false;
                throw value;
            }
            return pump("throw", value);
        };
    }
    if (typeof inner.return === "function") {
        iter.return = function(value) {
            return pump("return", value);
        };
    }
    return iter;
}
function _async_iterator(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(s);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _await_async_generator(value) {
    return new _await_value(value);
}
function _await_value(value) {
    this.wrapped = value;
}
function _wrap_async_generator(fn) {
    return function() {
        return new _async_generator(fn.apply(this, arguments));
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var getFilesAndDirectoriesFromDirectory = require("./getFilesAndDirectoriesFromDirectory.js");
/**
 * Interop between deprecated webkitGetAsEntry and standard getAsFileSystemHandle.
 */ function getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        // eslint-disable-next-line no-nested-ternary
        kind: entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
        name: entry.name,
        getFile: function getFile() {
            return new Promise(function(resolve, reject) {
                return entry.file(resolve, reject);
            });
        },
        values: function values() {
            return _wrap_async_generator(function() {
                var directoryReader, entries;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // If the file is a directory.
                            directoryReader = entry.createReader();
                            return [
                                4,
                                _await_async_generator(new Promise(function(resolve) {
                                    getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
                                        onSuccess: function(dirEntries) {
                                            return resolve(dirEntries.map(function(file) {
                                                return getAsFileSystemHandleFromEntry(file, logDropError);
                                            }));
                                        }
                                    });
                                }))
                            ];
                        case 1:
                            entries = _state.sent();
                            return [
                                5,
                                _ts_values(_async_generator_delegate(_async_iterator(entries), _await_async_generator))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
}
function createPromiseToAddFileOrParseDirectory(entry, relativePath) {
    return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}
function _createPromiseToAddFileOrParseDirectory() {
    _createPromiseToAddFileOrParseDirectory = _wrap_async_generator(function(entry, relativePath) {
        var file, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, handle, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(entry.kind === 'file')) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        _await_async_generator(entry.getFile())
                    ];
                case 1:
                    file = _state.sent();
                    if (!(file !== null)) return [
                        3,
                        3
                    ];
                    file.relativePath = relativePath ? "".concat(relativePath, "/").concat(entry.name) : null;
                    return [
                        4,
                        file
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        17
                    ];
                case 4:
                    if (!(entry.kind === 'directory')) return [
                        3,
                        17
                    ];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        11,
                        12,
                        17
                    ]);
                    _iterator = _async_iterator(entry.values());
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        _await_async_generator(_iterator.next())
                    ];
                case 7:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        10
                    ];
                    _value = _step.value;
                    handle = _value;
                    return [
                        5,
                        _ts_values(_async_generator_delegate(_async_iterator(createPromiseToAddFileOrParseDirectory(handle, "".concat(relativePath, "/").concat(entry.name))), _await_async_generator))
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        6
                    ];
                case 10:
                    return [
                        3,
                        17
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 12:
                    _state.trys.push([
                        12,
                        ,
                        15,
                        16
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        _await_async_generator(_iterator.return())
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        16
                    ];
                case 15:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 16:
                    return [
                        7
                    ];
                case 17:
                    return [
                        2
                    ];
            }
        });
    });
    return _createPromiseToAddFileOrParseDirectory.apply(this, arguments);
}
function getFilesFromDataTransfer(dataTransfer, logDropError) {
    return _getFilesFromDataTransfer.apply(this, arguments);
}
function _getFilesFromDataTransfer() {
    _getFilesFromDataTransfer = _wrap_async_generator(function(dataTransfer, logDropError) {
        var entries, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, lastResortFile, entry, err, err1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _await_async_generator(Promise.all(Array.from(dataTransfer.items, /*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(item) {
                                var _await$item$getAsFile, lastResortFile, entry;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            lastResortFile = item.getAsFile(); // Chromium bug, see https://github.com/transloadit/uppy/issues/3505.
                                            return [
                                                4,
                                                item.getAsFileSystemHandle == null ? void 0 : item.getAsFileSystemHandle()
                                            ];
                                        case 1:
                                            entry = (_await$item$getAsFile = _state.sent()) != null ? _await$item$getAsFile : getAsFileSystemHandleFromEntry(item.webkitGetAsEntry(), logDropError);
                                            return [
                                                2,
                                                {
                                                    lastResortFile: lastResortFile,
                                                    entry: entry
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }())))
                    ];
                case 1:
                    entries = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        12,
                        13,
                        14
                    ]);
                    _iterator = entries[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        11
                    ];
                    _step_value = _step.value, lastResortFile = _step_value.lastResortFile, entry = _step_value.entry;
                    if (!(entry != null)) return [
                        3,
                        10
                    ];
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        10
                    ]);
                    return [
                        5,
                        _ts_values(_async_generator_delegate(_async_iterator(createPromiseToAddFileOrParseDirectory(entry, '')), _await_async_generator))
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        10
                    ];
                case 6:
                    err = _state.sent();
                    if (!lastResortFile) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        lastResortFile
                    ];
                case 7:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    logDropError(err);
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        10
                    ];
                case 10:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    err1 = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err1;
                    return [
                        3,
                        14
                    ];
                case 13:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    });
    return _getFilesFromDataTransfer.apply(this, arguments);
}
module.exports = getFilesFromDataTransfer;
